module.exports = __webpack_public_path__ + "static/media/logo.33dec615.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/introduction/assets/logo.png
// module id = 189
// module chunks = 0